<template>
  <iColumn v-if="hasServicePackage">
    <iSubHeading>
      Service Packages
    </iSubHeading>

    <SmartFeed
      :source="useOrgExpertServicePackageFeedStore"
      default-feed-layout="grid"
      default-entity-size="small"
      load-more-behavior="auto"
    />
  </iColumn>
</template>

<script>
import { mapState } from "pinia";
import { useGeneralStore } from "%/stores/general-store";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import { useOrgExpertServicePackageFeedStore } from "@/smart-feed/stores/feed/org-expert-service-package-feed-store";

export default {
  name: "OrgServicePackages",
  components: { SmartFeed },
  props: {
    orgId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState(useGeneralStore, ["orgData"]),
    ...mapState(useOrgExpertServicePackageFeedStore, ["feed"]),
    hasServicePackage() {
      return this.feed.length > 0;
    },
  },
  methods: { useOrgExpertServicePackageFeedStore },
};
</script>
